module.exports = __webpack_public_path__ + "static/media/store.415794a5.svg";